import React, { useContext, useEffect } from 'react';
import { useNavigation } from '../Handler/NavigationHandler';
import { AppContext } from '../DataProviders/AppStateProvider';

/**
 * 404 Handler for navigation
 * In this case it stupidly redirects to the first page
 *
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
const StepInitial = props => {
  const { appData, updateAppData } = useContext(AppContext);
  const { handleStepClick } = useNavigation();

  useEffect(() => {
    handleStepClick(Object.keys(appData.journeys[appData.currentJourney])[0]);
  }, []);

  return (<></>);
}

export default StepInitial;
